import * as tslib_1 from "tslib";
import m from 'mithril';
import { Component } from '../ui/component';
var Page = /** @class */ (function (_super) {
    tslib_1.__extends(Page, _super);
    function Page(vnode) {
        var _this = _super.call(this, vnode) || this;
        _this.currentRoute = _this.attrs.route;
        return _this;
    }
    Page.prototype.oninit = function (vnode) {
        _super.prototype.oninit.call(this, vnode);
        this.onroutechange();
    };
    Page.prototype.onafterupdate = function () {
        var last = this.currentRoute.href;
        this.currentRoute = this.attrs.route;
        if (last !== this.currentRoute.href)
            this.onroutechange();
    };
    Page.prototype.onroutechange = function () { };
    Page.render = function (attrs) {
        return m(this, attrs);
    };
    return Page;
}(Component));
export { Page };
